import { render, staticRenderFns } from "./PendingChargesModal.vue?vue&type=template&id=804727e4"
import script from "./PendingChargesModal.vue?vue&type=script&lang=ts"
export * from "./PendingChargesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports